import React, { Component } from 'react';
import { DatePicker, Select, Table } from 'antd';
import './OrderTransactionHistory.scss';
import moment from 'moment';
import utils from '../../common/utils';
import consts from '../../consts';
import 'moment/locale/vi';
import 'moment/locale/en-il';
import _ from 'lodash';
import Search from 'antd/lib/input/Search';

const { Option } = Select;
const { RangePicker } = DatePicker

const { COLOR_BUY, COLOR_SELL } = consts;

class OrderTransactionHistory extends Component {
  columns = [
    {
      title: 'ID',
      key: 'id',
      dataIndex: 'id',
      fixed: 'left',
      ellipsis: true,
    },
    {
      align: 'center',
      title: 'Tài Khoản',
      width: 250,
      dataIndex: 'transaction_type',
      render: (tranType, orderTrans) => <div
        style={{
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          width: 230,
          textOverflow: 'ellipsis',
        }}
        title={utils.isBuyOrder(tranType) ? orderTrans.buyer_pubkey : orderTrans.seller_pubkey}>
        {utils.isBuyOrder(tranType) ? orderTrans.buyer_pubkey : orderTrans.seller_pubkey}
      </div>
    },
    {
      align: 'center',
      title: 'Thời gian',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (createdAt) => utils.formatTimeFromUnix(createdAt, 'DD/MM/YYYY HH:mm'),
    },
    {
      align: 'center',
      title: 'Loại giao dịch',
      dataIndex: 'transaction_type',
      key: 'transaction_type',
      // render: (transactionType) => utils.parseOrderType(transactionType),
      render: (tranType) => <div style={{
        color: utils.isBuyOrder(tranType) ? COLOR_BUY : COLOR_SELL,
      }}>
        {utils.parseTradeType(tranType)}
      </div>,
    },
    {
      align: 'center',
      title: 'Cặp',
      dataIndex: 'pair',
      key: 'pair',
    },
    {
      align: 'center',
      title: 'Giá',
      dataIndex: 'price',
      key: 'price',
      render: (price) => utils.formatCurrency(price)
    },
    {
      align: 'center',
      title: 'Số lượng',
      dataIndex: 'quantity',
      key: 'quantity',
    },
    {
      align: 'center',
      title: 'Tổng số',
      dataIndex: 'amount',
      key: 'amount',
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      pos: 0,
      currentPage: 1,
      totalCount: 0,
      orderTransSearch: undefined,
      orderPairs:[],
    };
    this.filter = {
      coin: '',
      currency: '',
      trade_type: -1,
      begin: '',
      end: '',
      pos: 0,
      count: consts.DEFAULT_PAGE_SIZE,
    };
  }

  showOptionPairs(orderPairs) {
    let result = null;
    if (orderPairs.length > 0) {
      result = orderPairs.map((item, index) => {
        return (
          <Option
            key={index}
            value={`${item.coin}/${item.currency}`}
          >
            {item.coin}/{item.currency}
          </Option>
        );
      });
    }
    return result;
  }

  onChangePairs = (value) => {
    let [coin, currency] = value.value.split('/');
    this.filter = {
      ...this.filter,
      coin,
      currency,
    };
    this.setState({ currentPage: 1, });
    this.fetchData();
  };

  onTradeType = (value) => {
    let tradeType = value.value;
    this.filter.trade_type = parseInt(tradeType);
    this.setState({ currentPage: 1, });
    this.fetchData(this.filter);
  };

  onChangeDate = (value, date) => {
    if (value !== null) {
      let dateStart = value[0].startOf('day').toString()
      this.filter.begin = parseInt(moment(dateStart).valueOf() / 1000);
      let dateEnd = value[1].endOf('day').toString()
      this.filter.end = parseInt(moment(dateEnd).valueOf() / 1000);
    }
    else {
      this.filter.begin = ''
      this.filter.end = ''
    }
    this.setState({ currentPage: 1 })
    this.fetchData(this.filter)
  }

  componentDidMount() {
    this.fetchData();
  }

  updateTotalCount = (totalCount) => this.setState({
    totalCount,
    isLoading: false
  });

  fetchData = (pos = 0, count = consts.DEFAULT_PAGE_SIZE, isRefresh = false) => {
    if (isRefresh) {
      this.filter = {
        ...this.filter,
        pos: 0,
        count: consts.DEFAULT_PAGE_SIZE,
      };
      this.setState({ currentPage: 1, });
    } else {
      this.filter = {
        ...this.filter,
        pos,
        count,
      };
    }
    this.props.onFetchFilterTransactionHistoryAction(this.filter, this.updateTotalCount);
  };

  handleSearchOrderTrans = ({ currentTarget }) => {
    let orderTransSearch = undefined;
    if (_.isEmpty(`${currentTarget.value}`)) {
      // utils.showNotification("Cảnh báo", "Không để trống mục tìm kiếm", consts.TYPE_WARNING);
      this.setState({ orderTransSearch });
      return;
    }

    this.props.searchOrderTransByIDAction({ id: currentTarget.value }, (orderTransSearch) => {
      this.setState({orderTransSearch:{
        ...orderTransSearch,
        pair: `${orderTransSearch.coin}/${orderTransSearch.currency}`,
        amount: utils.formatCurrency(orderTransSearch.amount),
        quantity: utils.formatCurrency(orderTransSearch.quantity),
        fee: utils.formatCurrency(orderTransSearch.fee)
      }});
    });
  }

  render() {
    const { orderTransSearch } = this.state;

    return (
      <div className="OrderTransaction">
        <div>
          <h3>Lịch sử giao dịch lệnh</h3>
        </div>
        <div className="mt-medium mb-medium d-flex space-between">
          <div className="d-flex">
            <div className="mr-medium">
              <span className="Transaction-Bag">Cặp</span>
              <Select
                labelInValue
                defaultValue={{ value: 'Tất cả' }}
                style={{ width: 115 }}
                onChange={this.onChangePairs}
              >
                <Option value=""> Tất cả </Option>
                {this.showOptionPairs(this.props.coinSettings)}
              </Select>
            </div>
            <div className="Transaction__TradeStye">
              <span className="Transaction__TradeStye-Select">Loại giao dịch</span>
              <Select
                labelInValue
                defaultValue={{ value: 'Tất cả' }}
                style={{ width: 120 }}
                onChange={this.onTradeType}
              >
                <Option value="-1">Tất cả </Option>
                <Option value="0">Mua </Option>
                <Option value="1">Bán </Option>
              </Select>
            </div>

            <div className="d-flex">
              <RangePicker
                locale={consts.LangDateVi}
                disabledDate={(current) => current && current > moment().endOf('day')}
                onChange={this.onChangeDate}
                placeholder={['Ngày bắt đầu', 'Ngày kết thúc']}
                format="DD-MM-YYYY"
              />
            </div>
          </div>

          <div>
            <Search onSearch={(value) => this.handleSearchOrderTrans({ currentTarget: { value } })}
              placeholder={"Tìm kiếm theo ID"}
              onPressEnter={this.handleSearchOrderTrans} />
          </div>

        </div>
        <div className="Table">
          <Table
            columns={this.columns}
            dataSource={!!orderTransSearch ? [orderTransSearch] : this.props.orderTrans.orderTransactions || []}
            bordered
            pagination={!!orderTransSearch ? false : {
              showSizeChanger: false,
              current: this.state.currentPage,
              onChange: (page, pageSize) => {
                this.fetchData((page - 1) * pageSize, pageSize);
                this.setState({
                  currentPage: page,
                  isLoading: true
                });
              },
              defaultPageSize: 10,
              total: this.state.totalCount,
              hideOnSinglePage: true,
            }}
            loading={this.state.isLoading}
          />
        </div>
      </div>
    );
  }
}

export default OrderTransactionHistory;
